"use strict";var promise;
module.exports =
typeof queueMicrotask === "function" ?
queueMicrotask : (
promise = Promise.resolve(),
function (cb) {
  promise.then(cb);
});